import React from "react";
import {Howl} from "howler";

//this not here
const AUDIO_RES_URL:string='https://www.gamestolearnenglish.com/content-5/audio-bank/voice-';

interface PropsType{
    txtsList:string[];
    audioChosen:number;
}

export default class ContentAudioSample extends React.Component<PropsType>{

	private myAudio:Howl;

	constructor(props:PropsType){
		super(props);

		this.myAudio=new Howl({src:['']});

		this.audioItemClick=this.audioItemClick.bind(this);
	}

	audioItemClick(itemText:string){
		let myAudioStr=itemText.replace(/ /g,'_');
		let audioSrc=AUDIO_RES_URL+this.props.audioChosen.toString()+'/'+myAudioStr+'.mp3';

		this.myAudio.stop();
		this.myAudio=new Howl({src:[audioSrc]});
		this.myAudio.play();
	}

    render(){
		if(this.props.audioChosen===0)return;
        let items:React.ReactElement[]=[];
        for(let i=0;i<this.props.txtsList.length;i++){
            items.push(<ContentAudioItem 
                itemText={this.props.txtsList[i]}
				itemClick={this.audioItemClick}
                key={this.props.txtsList[i]+'-'+i} 
            />)
        }
		return(
			<div className='teachers-contentset-audiosamples'>
                {items}
			</div>
		)
	}
}

const ContentAudioItem=function(props:{itemText:string, itemClick:Function, key:string }){
    return(
		<div className="teachers-contentset-audioitem" onClick={()=>{props.itemClick(props.itemText)} }>
			<span className="teachers-contentset-audioitem-text">{props.itemText}</span>
			<div className='teachers-contentset-audioitem-icon'><AUDIO_ICON /></div>
		</div>
	)
};


const AUDIO_ICON = () => {
	return (
	  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

<path d="M12.2884 17.9125C12.2884 18.3452 12.0384 18.7383 11.6472 18.9217C11.4959 18.9933 11.3338 19.0279 11.1727 19.0279C10.9177 19.0279 10.6651 18.9402 10.461 18.771L4.36313 13.718H1.1154C0.499488 13.7186 0 13.2188 0 12.6029V8.15899C0 7.54281 0.499488 7.04332 1.1154 7.04332H4.36339L10.4613 1.99036C10.7944 1.71422 11.2564 1.65535 11.6474 1.84015C12.0384 2.02363 12.2887 2.41699 12.2887 2.84942L12.2884 17.9125ZM15.775 16.1695C15.7478 16.1714 15.7217 16.1724 15.6947 16.1724C15.4001 16.1724 15.116 16.056 14.9062 15.8459L14.757 15.6962C14.3657 15.3057 14.3198 14.6872 14.6493 14.2431C15.4846 13.1169 15.9255 11.7819 15.9255 10.3813C15.9255 8.87496 15.4249 7.46203 14.4777 6.29515C14.1171 5.85163 14.1503 5.20747 14.5545 4.80355L14.7034 4.65439C14.9262 4.43157 15.2248 4.31013 15.5479 4.3294C15.8626 4.34524 16.1565 4.49335 16.356 4.73728C17.67 6.34504 18.364 8.29706 18.364 10.3816C18.364 12.3231 17.7502 14.1711 16.5886 15.725C16.3946 15.9839 16.0978 16.1466 15.775 16.1695ZM19.5865 19.6166C19.3848 19.855 19.0931 19.9981 18.7808 20.0113C18.7655 20.0118 18.7499 20.0123 18.7341 20.0123C18.4387 20.0123 18.1551 19.8956 17.9452 19.6858L17.7987 19.5392C17.3893 19.13 17.3615 18.4756 17.7338 18.0326C19.5327 15.8931 20.5237 13.176 20.5237 10.3813C20.5237 7.47444 19.4627 4.67604 17.5368 2.50173C17.1464 2.06032 17.1662 1.39214 17.5817 0.97502L17.728 0.8285C17.945 0.610436 18.2269 0.490316 18.5503 0.500612C18.8574 0.509324 19.1478 0.64502 19.3518 0.8747C21.6798 3.49569 22.962 6.87225 22.962 10.3813C22.9626 13.7576 21.7637 17.0376 19.5865 19.6166Z" fill="#414141"/>
	  </svg>
	)
  };